import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { PictureData, Picture, PictureColumn } from '../../../shared/public-api';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'admin-picture-section',
  templateUrl: './picture-section.component.html',
  styleUrls: ['./picture-section.component.scss'],
  imports: [CommonModule, FormsModule, DialogModule],
})
export class PictureSectionComponent implements OnInit {
  @Input() sectionData: PictureData;
  @Output() sectionDataChange = new EventEmitter<any>();
  @ViewChild('pictureInput') pictureInput: ElementRef;

  baseUrl: string;

  pictureModel: Picture;
  edit = false;
  editColumn: PictureColumn;

  constructor() {
    this.baseUrl = environment.baseUrl;
  }

  ngOnInit(): void {
    if (!this.sectionData) {
      this.sectionData = new PictureData();
    }

    if (this.sectionData.pictureColumns) {
      this.fetchImages();
    }

    if (!this.sectionData.pictureColumns) {
      this.sectionData.pictureColumns = [];
      this.sectionData.pictureColumns.push(new PictureColumn(0));
    }
    this.sortPictureColumns();
  }

  addPicture(column: PictureColumn): void {
    let order = 0;
    this.editColumn = column;
    if (column.pictures?.length > 0) {
      order = Math.max(...column.pictures.map((p) => p.order)) + 1;
    }
    this.pictureModel = new Picture(order);
    this.edit = true;
  }

  addPictureToColumn(): void {
    if (!this.editColumn.pictures) {
      this.editColumn.pictures = [];
    }
    this.editColumn.pictures.push(this.pictureModel);
    this.pictureInput.nativeElement.value = '';
    this.edit = false;
  }

  onFileChanged(event: Event): void {
    const files = (event.target as HTMLInputElement)?.files;
    if (!files || files?.length === 0) {
      return;
    }
    const file = files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.pictureModel.uploadSrc = reader.result as string;
    };
    this.pictureModel.name = file.name;
  }

  addColumn(): void {
    let order = 0;
    if (this.sectionData.pictureColumns.length > 0) {
      order = Math.max(...this.sectionData.pictureColumns.map((p) => p.order)) + 1;
    }
    this.sectionData.pictureColumns.push(new PictureColumn(order));
  }

  updateColumnOrder(column: PictureColumn, direction: number): void {
    const newOrder = column.order + direction;
    if (newOrder < 0 || newOrder > this.sectionData.pictureColumns.length - 1) {
      return;
    }
    const columnToMove = this.sectionData.pictureColumns.find((x) => x.order === newOrder);
    if (columnToMove) {
      columnToMove.order -= direction;
    }
    column.order = newOrder;
    this.sortPictureColumns();
  }

  updatePictureColumnOrder(column: PictureColumn, picture: Picture, direction: number): void {
    const newOrder = picture.order + direction;
    if (newOrder < 0 || newOrder > column.pictures.length - 1) {
      return;
    }
    const pictureToMove = column.pictures.find((x) => x.order === newOrder);
    if (pictureToMove) {
      pictureToMove.order -= direction;
    }
    picture.order = newOrder;
    this.sortPictureColumns();
  }

  addColumnHasMargin(): boolean {
    return this.sectionData.pictureColumns[0].pictures.length > 0;
  }

  deletePicture(column: PictureColumn, picture: Picture): void {
    column.pictures
      .filter((p) => p.order > picture.order)
      .forEach((orderToUpdate) => (orderToUpdate.order -= 1));
    const pictureIndex = column.pictures.indexOf(picture);
    column.pictures.splice(pictureIndex, 1);
  }

  private sortPictureColumns(): void {
    if (this.sectionData.pictureColumns) {
      this.sectionData.pictureColumns = this.sectionData.pictureColumns.sort(
        (a, b) => a.order - b.order
      );
      this.sectionData.pictureColumns.forEach((column) => {
        column.pictures = column.pictures.sort((a, b) => a.order - b.order);
      });
    }
  }

  private fetchImages(): void {
    this.sectionData.pictureColumns.forEach((c) => {
      c.pictures.forEach((p) => {
        fetch(this.baseUrl + p.src).then((res) => {
          res.blob().then((blob) => {
            var reader = new FileReader();
            reader.onload = () => {
              p.uploadSrc = reader.result as string;
            };
            reader.readAsDataURL(blob);
          });
        });
      });
    });
  }
}
